import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { withRouter } from "react-router-dom";

import Link from "../common/Link";
import Loading from "../../components/Loading/DataLoading";
import styles from "./SidebarNavigation.module.scss";

import IconCardsSVG from "../svg/icon-cards";
import IconOrdersSVG from "../svg/icon-orders";
import IconStoreSVG from "../svg/icon-store";
import IconRevenuesSVG from "../svg/icon-revenues";
import IconReportsSVG from "../svg/icon-reports";
import IconPayoutSVG from "../svg/icon-payment";
import IconCompanySVG from "../svg/icon-company";
import IconUserSVG from "../svg/icon-person";
import IconAngelSideMenuSVG from "../svg/icon-angel-sideMenu";
import IconAffiliateSVG from "../svg/icon-affiliate";
import IconToolsSVG from "../svg/icon-tools";

import * as actions from "../../store/actions";
import withViewport from "../hoc/withViewport";
import { useTranslation } from "react-i18next";
import useDataLayer from "../hook/useDatalayer";

const SidebarNavigation = (props) => {
  const { style } = props;

  const { t } = useTranslation();

  const { sendDataToDataLayer } = useDataLayer();
  const sendEventHandler = (action, label) => {
    sendDataToDataLayer({
      event: "AngelDashboardEvent",
      eventCategory: "Angel dashboard",
      eventAction: action,
      eventLabel: label,
    });
  };

  const dispatch = useDispatch();

  const isShowSidebar = useSelector((state) => state.app.isShowSidebar);
  const { plan } = useSelector((state) => state.commission);
  const tokenInfo = useSelector((state) => state.auth.info);
  const { organization, id } = useSelector((state) => state.organization);

  const { isAffiliate, isAngel } = tokenInfo;

  const hasAffiliate = props.location.pathname.includes("affiliates");
  const hasAngel = props.location.pathname.includes("angel");

  const isMobile = props.viewport !== "desktop";

  useEffect(() => {
    isAffiliate && dispatch(actions.getCommissionPlan());
  }, [isAffiliate, dispatch]);

  return (
    <>
      {isMobile && (
        <div
          className={classNames([
            styles.backdrop,
            isShowSidebar && styles.active,
          ])}
          onClick={() => dispatch(actions.closeSidebar())}
        ></div>
      )}
      <div
        className={classNames([styles.menu, isShowSidebar && styles.active])}
        style={style}
      >
        <ul
          className={styles.menuList}
          onClick={() => dispatch(actions.closeSidebar())}
        >
          {hasAngel ? (
            <>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/angel/dashboard"}
                >
                  <IconCardsSVG className={styles.icon} />
                  {t("dashboard")}
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/angel/luggage-storage"}
                >
                  <IconStoreSVG className={styles.icon} />
                  {t("Manage operating hours")}
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/angel/luggage-storage/orders"}
                  onClick={sendEventHandler(
                    "Orders",
                    "user navigates to orders section"
                  )}
                >
                  <IconOrdersSVG className={styles.icon} />
                  {t("orders")}
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/angel/luggage-storage/revenue"}
                  onClick={sendEventHandler(
                    "Revenues",
                    "user navigates to revenues section"
                  )}
                >
                  <IconRevenuesSVG className={styles.icon} />
                  {t("revenue")}
                </Link>
              </li>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/angel/company"}
                  onClick={sendEventHandler(
                    "Company",
                    "user navigates to company information section"
                  )}
                >
                  <IconCompanySVG className={styles.icon} />
                  {t("company")}
                </Link>
              </li>
              {(organization || id) && (
                <li className={styles.item}>
                  <Link
                    className={styles.link}
                    isNavLink={true}
                    activeClassName={styles.active}
                    to={`/angel/payment`}
                    onClick={sendEventHandler(
                      "Payment",
                      "user navigates to payment settings"
                    )}
                  >
                    <IconPayoutSVG className={styles.icon} />
                    {t("Payment")}
                  </Link>
                </li>
              )}
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/angel/profile"}
                  onClick={sendEventHandler(
                    "Profile",
                    "user navigates to profile settings"
                  )}
                >
                  <IconUserSVG className={styles.icon} />
                  {t("Profile")}
                </Link>
              </li>
              {!!isAffiliate && (
                <li className={styles.item}>
                  <Link
                    className={styles.link}
                    to={"/affiliates/dashboard"}
                    onClick={sendEventHandler(
                      "Affiliate area",
                      "user navigates to Affiliate area"
                    )}
                  >
                    <IconAffiliateSVG
                      className={classNames([styles.icon, styles.svgAffiliate])}
                    />
                    {t("affiliate area")}
                  </Link>
                </li>
              )}
            </>
          ) : (
            <>
              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/affiliates/dashboard"}
                >
                  <IconCardsSVG className={styles.icon} />
                  {t("dashboard")}
                </Link>
              </li>
              <li className={styles.item}>
                <Link className={styles.link}>
                  <IconReportsSVG className={styles.icon} />
                  {t("reports")}
                </Link>
                <ul>
                  <li>
                    <Link
                      className={styles.sublink}
                      isNavLink={true}
                      activeClassName={styles.active}
                      to={"/affiliates/dashboard/commission"}
                    >
                      {t("commission")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li className={styles.item}>
                <Link className={styles.link}>
                  <IconToolsSVG className={styles.icon} />
                  {t("tools")}
                </Link>
                <ul>
                  <li>
                    <Link
                      className={styles.sublink}
                      isNavLink={true}
                      activeClassName={styles.active}
                      to={"/affiliates/dashboard/links"}
                    >
                      {t("link generator")}
                    </Link>
                  </li>
                  {plan && (
                    <li>
                      <Link
                        className={styles.sublink}
                        isNavLink={true}
                        activeClassName={styles.active}
                        to={"/affiliates/dashboard/programs"}
                      >
                        {t("Programs")}
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      className={styles.sublink}
                      isNavLink={true}
                      activeClassName={styles.active}
                      to={"/affiliates/dashboard/marketing_collateral"}
                    >
                      {t("Marketing collateral")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li className={styles.item}>
                <Link
                  className={styles.link}
                  isNavLink={true}
                  activeClassName={styles.active}
                  to={"/affiliates/profile"}
                >
                  <IconUserSVG className={styles.icon} />
                  {t("Profile")}
                </Link>
              </li>
              {!!isAngel && (
                <li className={styles.item}>
                  <Link
                    className={styles.link}
                    to={"/angel/dashboard"}
                    onClick={sendEventHandler(
                      "Angel area",
                      "user navigates to Angel area"
                    )}
                  >
                    <IconAngelSideMenuSVG
                      className={classNames([styles.icon, styles.svgAngel])}
                    />
                    {t("Angel area")}
                  </Link>
                </li>
              )}
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default withRouter(withViewport(SidebarNavigation));
